import { Controller } from '@hotwired/stimulus'
import ProgressWheelController from './progress-wheel'
import TooltipController from './tooltip'

type BusyElementsState = 'idle' | 'indeterminate' | 'progress'

export default class BusyElementsController extends Controller {
  declare readonly busyTarget: Element
  declare readonly progressTarget: Element
  declare readonly hasProgressTarget: boolean
  declare readonly hasBusyTarget: boolean
  declare readonly tooltipOutlet: TooltipController
  declare readonly progressWheelOutlet: ProgressWheelController
  declare readonly hasTooltipOutlet: boolean
  declare readonly hasProgressWheelOutlet: boolean
  declare stateValue: BusyElementsState

  static targets = ['busy', 'progress']

  static values = {
    state: {
      type: String,
      default: 'idle',
    },
    progress: Number,
  }

  static outlets = ['tooltip', 'progress-wheel']

  setState(
    newState: BusyElementsState,
    { progressTo = null, tooltipTo = null }: { progressTo?: number; tooltipTo?: string } = {},
  ) {
    this.stateValue = newState
    if (progressTo !== null && this.hasProgressWheelOutlet) this.progressWheelOutlet.setTo(progressTo)
    if (tooltipTo !== null && this.hasTooltipOutlet) this.setTooltip(tooltipTo)
  }

  stateValueChanged() {
    this.element.classList.remove('busy', 'indeterminate', 'progress')
    if (this.stateValue !== 'idle') {
      this.element.classList.add('busy', this.stateValue)
    }
  }

  setTooltip(newContent: string) {
    this.tooltipOutlet.element.tooltip.setContent(newContent)
  }
}
